<template>
  <Block type="cards">
    <Container>
      <h3 class="h3">
        <small>{{ $t("our_api") }}</small>
        {{ $t("advantages") }}
      </h3>

      <div class="cards">
        <div class="card">
          <svgicon name="upload" />
          <h4 class="h4">{{ $t("reliability_and_timeliness") }}</h4>
          <p>{{ $t("reliability_description") }}</p>
          <div class="card__footer">
            <div class="card__api card__api--online">{{ $t("api_state") }}</div>
          </div>
        </div>
        <div class="card">
          <svgicon name="coding" />
          <h4 class="h4">{{ $t("interactive_documentation") }}</h4>
          <p>{{ $t("interactive_description") }}</p>
          <div class="card__footer">
            <router-link :to="localizedLink('documentation')">{{
              $t("documentation")
            }}</router-link>
          </div>
        </div>
        <div class="card">
          <svgicon name="time" />
          <h4 class="h4">{{ $t("quick_implementation") }}</h4>
          <p>{{ $t("quick_description") }}</p>
          <div class="card__footer">
            <router-link :to="localizedLink(authorizationLink)">{{
              $t("get_api_key")
            }}</router-link>
          </div>
        </div>
      </div>
    </Container>
  </Block>
</template>

<script>
import Block from "@/components/homepage/Block";
import Container from "@/components/homepage/Container";

export default {
  props: {
    authorizationLink: {
      type: Object,
      required: true
    }
  },
  components: {
    Block,
    Container
  }
};
</script>

<style lang="scss" scoped>
.cards {
  @media (min-width: $breakpoint-md) {
    display: flex;
    flex-wrap: nowrap;
    width: calc(100% + #{$--gutter-landing-width});
    margin-left: -$--gutter-landing-width / 2;
    margin-right: -$--gutter-landing-width / 2;
  }
}

.card {
  margin-bottom: 15px;
  padding: 25px 30px 28px;
  font-size: rem(14);
  box-shadow: 0px 10px 15px rgba(88, 87, 90, 0.3);
  border-radius: 5px;
  background-color: $--color-white;
  @media (min-width: $breakpoint-md) {
    max-width: calc((100% / 3) - #{$--gutter-landing-width});
    flex-basis: calc((100% / 3) - #{$--gutter-landing-width});
    margin-left: $--gutter-landing-width / 2;
    margin-right: $--gutter-landing-width / 2;
    margin-bottom: 0;
  }
  .svg-icon {
    width: 60px;
    height: 60px;
    fill: $--color-landing-primary;
    stroke: $--color-landing-primary;
  }
}

.card__footer {
  margin-top: 20px;
  font-weight: 700;
}

.card__api {
  position: relative;
  font-size: rem(12);
  letter-spacing: $--leter-spacing-xl;
  text-transform: uppercase;
  &::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: 8px;
    margin-right: 8px;
    border-radius: 50%;
  }
}

.card__api--online {
  color: $--color-green;
  &::before {
    background-color: $--color-green;
  }
}

.card__api--processing {
  color: $--color-yellow;
  &::before {
    background-color: $--color-yellow;
  }
}

.card__api--error {
  color: $--color-red;
  &::before {
    background-color: $--color-red;
  }
}
</style>
